import { Box, FormControlLabel, FormLabel, Rating } from "@mui/material";
import React, { useState } from "react";

function NCXFormRating(props) {
    const [localValue, setLocalValue] = useState();
    const fieldname = props?.field?.properties?.fieldname;

    const onRatingChange = (value) => {
        setLocalValue(value);
        props?.handleInputChange(fieldname, value, props?.field)
    }

    const sharedBorder = { 
        border: '1px solid #bdbdbd', 
        borderRadius: '4px', 
        padding: '2px 2px 0 2px', 
        height: '3em', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-start' 
    }

    return (
        <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
            <FormLabel>{props?.field?.properties?.label}</FormLabel>
            <Box sx={sharedBorder}>
                <Rating disabled={props?.field?.properties?.readOnly} size="large" value={localValue} onChange={(e, v) => onRatingChange(v)} />
            </Box>
        </Box>
    )
}

export default NCXFormRating;